import { Routes } from '@angular/router';
import { GamesComponent } from './games/games.component';
import { AdminLayoutComponent } from './admin/admin-layout.component';
import { ClientsListComponent } from './admin/pages/clients-list.component';
import { ClientEditComponent } from './admin/pages/client-edit.component';
import { LeaderboardComponent } from './admin/pages/leaderboard.component';

export const routes: Routes = [
  { path: '', component: GamesComponent },
  {
    path: 'admin',
    component: AdminLayoutComponent,
    children: [
      { path: '', component: ClientsListComponent },
      { path: 'client/:code', component: ClientEditComponent },
      { path: 'leaderboard', component: LeaderboardComponent },
    ],
  },
  { path: '**', redirectTo: '' },
];
